import React from 'react'
import { wrapView, request } from '../smart_bps/lib/utils'
import { stateToProps } from '../smart_bps/bps/base_view'
import { store } from '../index'
import { Link } from 'react-router-dom'
import { PROJECT_NAME } from './constants'
import { SigurListView } from '../lib/SigurListView'
import { ApprovalsModalSearch } from './ApprovalsModalSearch'
import { SigurModalOrderColumn } from '../common_components/modal_order_column'
import AcceptQueueTopButton from '../lib/AcceptQueueTopButton'

const STATE_FILTERS = [
  { value: 'all', label: 'Все' },
  { value: 'current_approvals', label: 'Согласование заявки' },
  { value: 'returned', label: 'Ожидание доработок' },
  { value: 'done', label: 'Выполнены' },
]

class ListView extends SigurListView {
  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      stateCounters: {},
    }
    this.loadStateCounters = this.loadStateCounters.bind(this)
  }

  componentDidMount() {
    this.applyDefaultStateFilter()
    this.loadStateCounters()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      this.applyDefaultStateFilter()
    }
    if ((prevProps.search_data !== this.props.search_data) || (prevProps.search_preset !== this.props.search_preset)) {
      this.loadStateCounters()
    }
  }

  applyDefaultStateFilter() {
    if (this.defaultStateApplied) return
    const roles = Array.isArray(this.props.user?.roles) ? this.props.user.roles : []
    if (roles.length === 0) return

    let defaultState = ''
    if (roles.length === 1 && roles[0] === 'applicant') {
      defaultState = 'draft'
    } else if (roles.length === 1 && roles[0] === 'case_owner') {
      defaultState = 'validation'
    }

    this.defaultStateApplied = true
    this.setStateFilter(defaultState)
  }

  setStateFilter(value) {
    const base = this.props.search_data || {}
    const newData = value ? { ...base, state: value } : (() => {
      const { state: _s, ...rest } = base
      return rest
    })()
    store.dispatch({ type: `${this.project_name}_search`, data: newData })
  }

  renderTopPanelLeftItems() {
    let items = super.renderTopPanelLeftItems()
    items = items && items.filter((item) => item?.key !== 'presets')
    const refreshKey = `${this.props.list_page || 1}-${(this.props.list_items || []).length}`
    items.push(
      <AcceptQueueTopButton
        key="approval_queue"
        projectName={PROJECT_NAME}
        label="Заявки на согласование"
        countUrl="/api/approvals/approval_queue"
        takeUrl="/api/approvals/approval_queue/take_next"
        refreshKey={refreshKey}
      />
    )
    items.push(super.getPresetBtn())
    return items
  }

  renderModals() {
    let modals = [
      <SigurModalOrderColumn project_name={this.project_name}
      attrs={this.props.attrs}
      table_headers={this.props.table_headers}
      user_table_headers={this.props.user_table_headers} />
    ]

    if (this.props.search_form) {
      modals.push(
        <ApprovalsModalSearch
          key="search"
          project_name={this.project_name}
          schema={this.props.search_form}
          data={this.props.search_data}
          onSearch={this.onSearch}
          choices={this.props.choices}
        />,
      )
    }

    return [...modals, ...(super.renderModals() || [])]
  }

  loadStateCounters() {
    const current = this.props.search_data || {}
    const { state: _state, ...baseFilterData } = current

    STATE_FILTERS.forEach(({ value }) => {
      const key = value || '__all__'
      const filter_data = value ? { ...baseFilterData, state: value} : baseFilterData

      request({
        method: 'post',
        url: `/api/${this.project_name}/get_preset_counter`,
        data: {
          filter_data,
          preset: this.props.search_preset,
        },
        success: (count) => {
          this.setState((prev) => ({
            stateCounters: { ...prev.stateCounters, [key]: count || 0 },
          }))
        },
      })
    })
  }

  renderContent() {
    const searchData = this.props.search_data || {}
    const currentState = searchData.state || 'current_approvals'
    const stateCounters = this.state.stateCounters || {}
    const chips = (
      <div className="card mb-3">
        <div className="card-body py-2">
          <span className="me-2 text-muted small">Этап:</span>
          {STATE_FILTERS.map(({ value, label }) => (
            <button
              key={value}
              type="button"
              className={`btn btn-sm me-1 ${currentState === value ? 'btn-primary' : 'btn-outline-secondary'}`}
              onClick={() => this.setStateFilter(value)}
            >
              {label} ({stateCounters[value || '__all__'] ?? 0})
            </button>
          ))}
        </div>
      </div>
    )
    const content = super.renderContent()
    return [chips, ...(Array.isArray(content) ? content : [content])]
  }

  renderTrTd(row, attr_name, idx) {
    if (attr_name === "request_id") {
      const content = row[attr_name]
      return <td key={attr_name}>
        <Link to={`/requests/${content}/`} className="me-1">
            {content}
          </Link>
      </td>
    } else {
      return super.renderTrTd(row, attr_name, idx)
    }
  }
}

export default wrapView(ListView, (state) => stateToProps(state, PROJECT_NAME))
